var React = require('react');

function CardboardBoxInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"stroke":"#f8bf29","strokeMiterlimit":"10","strokeWidth":"14","key":0},[React.createElement("path",{"d":"M392.4 17.1l-18.7-9.4L81.1 139 10.6 243.8l290.1 118.1L371 259.3 81.1 139m568.1 4.7L371 259.3l69.3 104.9 281.8-117.5-72.9-103-53.4-26.2","key":0}),React.createElement("path",{"d":"M79.3 270.8q-.3 109.4-.5 218.8l290.8 121.3 1.2-350.5m2.6 354.5l292.5-124.5.9-219.9","key":1})]),React.createElement("path",{"d":"M413 28.2l160.1 78.1","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"14","key":1})]);
}

CardboardBoxInline.defaultProps = {"viewBox":"0 0 732.8 621.4","fill":"none"};

module.exports = CardboardBoxInline;

CardboardBoxInline.default = CardboardBoxInline;
